// 2) Third-party libraries
import { all, call, fork, put, takeLatest } from "redux-saga/effects";

// 3.3 Project-specific modules � components/other
import client from "src/api";
import { _queries as queries } from "../../graphql/queries.graphql";

// 3.4 Utility functions / types
import { DynamicObject } from "../../utils/commonInterfaces";

// 3.5 Redux actions
import { getAllRolesRequestAction, getAllRolesSuccessAction } from "./roleSlice";

function* handleGetAllRolesRequest() {
    try {
        const res: DynamicObject = yield call(
            [client, client.graphql],
            {
                query: queries.GET_ALL_ROLES
            }
        );

        if (res.error) {
            console.log('res.error', res.error);
        }
        else {
            yield put(getAllRolesSuccessAction(res.data.GetAllRoles.Roles));
        }
    }
    catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        }
        else {
            console.error('An unknown error occured.');
        }
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchGetAllRolesRequest() {
    yield takeLatest(
        getAllRolesRequestAction.type,
        handleGetAllRolesRequest
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* rolesSaga() {
    yield all([fork(watchGetAllRolesRequest)]);
}

export default rolesSaga;
